module.exports = __webpack_public_path__ + "static/media/balance.daf92b74.png";